import { DataModel } from "common/models/utility-models/base-model";

export class KtLogsModel extends DataModel {
   
    studentName:any='';
    semester:any='';
    kt: any = '';
    createdAt: any = '';
}